import { useInfiniteQuery } from "@tanstack/react-query";
import {
  imagesControllerGetLibrary,
  getImagesControllerGetLibraryQueryKey,
} from "@/lib/lutely-api/gen/images/images";

export function useImageLibrary(
  creatorId: string,
  {
    pageSize = 15,
    enabled = true,
  }: { pageSize?: number; enabled?: boolean } = {},
) {
  return useInfiniteQuery({
    queryKey: getImagesControllerGetLibraryQueryKey({
      creatorId,
      pageSize,
    }),
    enabled: enabled && Boolean(creatorId),
    initialPageParam: 0,
    queryFn: ({ pageParam, signal }) =>
      imagesControllerGetLibrary(
        {
          creatorId,
          pageNumber: pageParam,
          pageSize,
        },
        undefined,
        signal,
      ),
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
  });
}
